import { getHostUxStrings } from '../stringTypes/HostUxStrings';
const stringTableFetcher = (locale)=>{
    return import(/* webpackChunkName: "hostUxStrings" */ `../translations/${locale}/HostUxStrings.json`);
};
export function getStringTable(locale) {
    return getHostUxStrings(stringTableFetcher, locale);
}
export async function getStringTableIfNeeded(stringTableOrLocale) {
    if (isStringTable(stringTableOrLocale)) {
        return stringTableOrLocale;
    }
    return await getStringTable(stringTableOrLocale);
}
export function isStringTable(stringTableOrLocale) {
    return typeof stringTableOrLocale === 'object';
}
